var _rect, _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _g2, _path0, _g3, _path1, _path10, _g4, _path11, _path12, _path13, _g5, _path14, _path15, _path16, _path17, _path18, _g6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10076_88545)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 63,
    rx: 9,
    fill: "#E4E1F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4234 32.8353L28.3154 32.8295C21.7813 32.7861 16.6993 30.8793 13.2092 27.1527C7.74519 21.3225 8.23794 13.2211 8.26127 12.8797L8.32541 11.9393L9.27884 11.8728C9.27884 11.8728 9.54709 11.8525 10.0194 11.8525C13.2384 11.8525 29.2951 12.8131 29.4176 31.7358L29.4234 32.8353Z",
    fill: "url(#paint0_linear_10076_88545)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2829 24.857L30.528 24.0995C26.0752 19.633 23.9124 14.872 24.099 9.94832C24.3902 2.23869 30.333 -2.97961 30.5874 -3.19564L31.2829 -3.79883L31.9812 -3.19564C32.2357 -2.97961 38.1784 2.23869 38.4696 9.94832C38.6562 14.872 36.4934 19.633 32.0406 24.0995L31.2829 24.857Z",
    fill: "url(#paint1_linear_10076_88545)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8711 32.8361L33.8797 31.7587C33.9997 13.2148 49.735 12.2734 52.8866 12.2734C53.3524 12.2734 53.6153 12.2933 53.6153 12.2933L54.5467 12.3585L54.6125 13.28C54.6353 13.6146 55.1182 21.551 49.7636 27.2673C46.3462 30.9194 41.363 32.7879 34.9569 32.8305L33.8711 32.8361Z",
    fill: "url(#paint2_linear_10076_88545)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6517 76.5576V24.8961C39.4983 24.8857 39.3475 24.8857 39.194 24.8857H23.8813V76.5576H39.6517ZM19.9569 76.5576H23.8813V24.8961H23.7955C17.4499 24.8961 11.8792 30.0343 11.4215 36.3082L9.27596 65.1584C8.80524 71.4193 13.6139 76.5576 19.9569 76.5576ZM43.03 76.5576C49.3756 76.5576 54.1817 71.4193 53.7135 65.1455L51.5654 36.2978C51.1077 30.1763 45.7893 25.1361 39.6413 24.8961V76.5576H43.03Z",
    fill: "#FFDE59"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10076_88545",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 23,
    width: 21,
    height: 21
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5107 23.1973H54.7803V43.3117H34.5107V23.1973Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10076_88545)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_10076_88545",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 23,
    width: 21,
    height: 21
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6475 23.1992C39.0483 23.1992 34.5127 27.7001 34.5127 33.2564C34.5127 38.8102 39.0483 43.3136 44.6475 43.3136C50.2441 43.3136 54.7823 38.8102 54.7823 33.2564C54.7823 27.7001 50.2441 23.1992 44.6475 23.1992Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_10076_88545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.5127 23.1992H54.7823V43.3136H34.5127V23.1992Z",
    fill: "white"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8955 40.1941C46.2123 43.7519 37.9166 40.8783 36.3125 39.0537C38.375 42.0186 39.177 42.1326 41.927 43.1589C44.7915 44.0712 46.2611 45.3256 47.3123 45.3256C48.5727 45.3256 47.7785 43.332 48.3435 43.1589C49.8331 42.7028 50.1768 45.3256 51.8955 45.3256C53.7288 45.3256 52.583 41.2204 52.3538 40.6502C52.1705 40.1941 52.0101 40.08 51.8955 40.1941Z",
    fill: "#ECECFC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0722 28.875C39.5795 28.875 36.75 31.6829 36.75 35.1488C36.75 38.6122 39.5795 41.42 43.0722 41.42C46.5623 41.42 49.3918 38.6122 49.3918 35.1488C49.3918 31.6829 46.5623 28.875 43.0722 28.875Z",
    fill: "#3D1F1E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_10076_88545",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 44,
    width: 19,
    height: 22
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5254 44.959H40.9304V65.7342H22.5254V44.959Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_10076_88545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7257 71.1753C31.1215 71.1753 30.524 71.0924 29.9332 70.923C29.3391 70.7571 28.765 70.5081 28.2076 70.1794C27.6501 69.8474 27.1194 69.4457 26.6187 68.9677C26.1147 68.4896 25.6508 67.9452 25.2235 67.3377C24.7963 66.7268 24.4158 66.0662 24.082 65.3491C23.7448 64.6354 23.4611 63.8785 23.2308 63.0817C23.0005 62.2883 22.8269 61.4683 22.7068 60.6251C22.5899 59.7785 22.5332 58.9287 22.5332 58.0655C22.5332 57.2057 22.5899 56.3525 22.7068 55.5093C22.8269 54.666 23.0005 53.8461 23.2308 53.0493C23.4611 52.2559 23.7448 51.499 24.082 50.7852C24.4158 50.0681 24.7963 49.4075 25.2235 48.7967C25.6508 48.1891 26.1147 47.6447 26.6187 47.1666C27.1194 46.6886 27.6501 46.2869 28.2076 45.9549C28.765 45.6263 29.3391 45.3773 29.9332 45.2113C30.524 45.042 31.1215 44.959 31.7257 44.959C32.3298 44.959 32.9273 45.042 33.5181 45.2113C34.1122 45.3773 34.6864 45.6263 35.2438 45.9549C35.8012 46.2869 36.3319 46.6886 36.8326 47.1666C37.3366 47.6447 37.8006 48.1891 38.2278 48.7967C38.6551 49.4075 39.0356 50.0681 39.3694 50.7852C39.7065 51.499 39.9902 52.2559 40.2205 53.0493C40.4509 53.8461 40.6244 54.666 40.7446 55.5093C40.8614 56.3525 40.9182 57.2057 40.9182 58.0655C40.9182 58.9287 40.8614 59.7785 40.7446 60.6251C40.6244 61.4683 40.4509 62.2883 40.2205 63.0817C39.9902 63.8785 39.7065 64.6354 39.3694 65.3491C39.0356 66.0662 38.6551 66.7268 38.2278 67.3377C37.8006 67.9452 37.3366 68.4896 36.8326 68.9677C36.3319 69.4457 35.8012 69.8474 35.2438 70.1794C34.6864 70.5081 34.1122 70.7571 33.5181 70.923C32.9273 71.0924 32.3298 71.1753 31.7257 71.1753Z",
    fill: "#3D1F1E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_10076_88545",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 58,
    width: 17,
    height: 12
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9424 58.0957H39.8573V69.4726H23.9424V58.0957Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_10076_88545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.8573 63.7825C39.8573 64.1543 39.8039 64.5228 39.7038 64.8913C39.6003 65.2565 39.4501 65.6117 39.2498 65.957C39.0496 66.3022 38.8059 66.6276 38.5155 66.9396C38.2251 67.2484 37.8947 67.5372 37.5241 67.7994C37.157 68.065 36.7531 68.3007 36.3192 68.5066C35.8853 68.7157 35.428 68.8883 34.944 69.0311C34.46 69.1738 33.9626 69.2834 33.452 69.3564C32.9379 69.4295 32.4206 69.466 31.8998 69.466C31.3758 69.466 30.8584 69.4295 30.3477 69.3564C29.8337 69.2834 29.3364 69.1738 28.8524 69.0311C28.3717 68.8883 27.9111 68.7157 27.4772 68.5066C27.0433 68.3007 26.6394 68.065 26.2722 67.7994C25.9017 67.5372 25.5713 67.2484 25.2809 66.9396C24.9905 66.6276 24.7468 66.3022 24.5465 65.957C24.3463 65.6117 24.1961 65.2565 24.0926 64.8913C23.9925 64.5228 23.9424 64.1543 23.9424 63.7825C23.9424 63.4074 23.9925 63.0389 24.0926 62.6704C24.1961 62.3052 24.3463 61.95 24.5465 61.6047C24.7468 61.2595 24.9905 60.9341 25.2809 60.6221C25.5713 60.3133 25.9017 60.0245 26.2722 59.7622C26.6394 59.4967 27.0433 59.2609 27.4772 59.0551C27.9111 58.846 28.3717 58.6733 28.8524 58.5306C29.3364 58.3878 29.8337 58.2783 30.3477 58.2053C30.8584 58.1322 31.3758 58.0957 31.8998 58.0957C32.4206 58.0957 32.9379 58.1322 33.452 58.2053C33.9626 58.2783 34.46 58.3878 34.944 58.5306C35.428 58.6733 35.8853 58.846 36.3192 59.0551C36.7531 59.2609 37.157 59.4967 37.5241 59.7622C37.8947 60.0245 38.2251 60.3133 38.5155 60.6221C38.8059 60.9341 39.0496 61.2595 39.2498 61.6047C39.4501 61.95 39.6003 62.3052 39.7038 62.6704C39.8039 63.0389 39.8573 63.4074 39.8573 63.7825Z",
    fill: "#FA5B5B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_10076_88545",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 23,
    width: 21,
    height: 21
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24023 23.334H28.5098V43.4484H8.24023V23.334Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_10076_88545)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_10076_88545",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 23,
    width: 21,
    height: 21
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.375 23.3379C12.7784 23.3379 8.24023 27.8387 8.24023 33.3951C8.24023 38.9489 12.7784 43.4523 18.375 43.4523C23.9717 43.4523 28.5098 38.9489 28.5098 33.3951C28.5098 27.8387 23.9717 23.3379 18.375 23.3379Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_10076_88545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.24023 23.3379H28.5098V43.4523H8.24023V23.3379Z",
    fill: "white"
  })))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7608 40.0802C16.444 43.6381 22.5626 42.0188 26.8252 39.168C24.9688 41.4487 23.5707 42.475 20.5001 43.6153C17.6125 44.5276 17.4264 44.9837 16.3752 44.9837C15.1148 44.9837 15.3592 43.4462 14.7942 43.2732C13.3046 42.8171 12.9609 44.8697 11.2422 44.8697C9.16704 44.8697 9.72953 41.4487 9.95869 40.8785C10.142 40.4223 10.6462 39.9662 10.7608 40.0802Z",
    fill: "#ECECFC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_10076_88545",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 28,
    width: 13,
    height: 14
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 28.876H25.7642V41.421H13.125V28.876Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_10076_88545)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_10076_88545",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 28,
    width: 13,
    height: 14
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4475 28.876C15.9575 28.876 13.1279 31.6838 13.1279 35.1498C13.1279 38.6132 15.9575 41.421 19.4475 41.421C22.9376 41.421 25.7672 38.6132 25.7672 35.1498C25.7672 31.6838 22.9376 28.876 19.4475 28.876Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_10076_88545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1279 28.876H25.7672V41.421H13.1279V28.876Z",
    fill: "#3D1F1E"
  })))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1249 40.9111C21.1249 39.3215 22.3143 38.1756 23.8749 38.1756C22.3868 38.1756 21.1262 36.9549 21.1262 35.4388C21.1262 36.9405 19.9498 38.1756 18.375 38.1756C19.9498 38.1756 21.1249 39.3792 21.1249 40.9111Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1249 35.4375L21.1262 35.4388M21.1262 35.4388C21.1262 36.9549 22.3868 38.1756 23.8749 38.1756C22.3143 38.1756 21.1249 39.3215 21.1249 40.9111C21.1249 39.3792 19.9498 38.1756 18.375 38.1756C19.9498 38.1756 21.1262 36.9405 21.1262 35.4388Z",
    stroke: "white",
    strokeWidth: 0.227852,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1249 40.9111C42.1249 39.3215 43.3143 38.1756 44.8749 38.1756C43.3868 38.1756 42.1262 36.9549 42.1262 35.4388C42.1262 36.9405 40.9498 38.1756 39.375 38.1756C40.9498 38.1756 42.1249 39.3792 42.1249 40.9111Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1249 35.4375L42.1262 35.4388M42.1262 35.4388C42.1262 36.9549 43.3868 38.1756 44.8749 38.1756C43.3143 38.1756 42.1249 39.3215 42.1249 40.9111C42.1249 39.3792 40.9498 38.1756 39.375 38.1756C40.9498 38.1756 42.1262 36.9405 42.1262 35.4388Z",
    stroke: "white",
    strokeWidth: 0.227852,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.01
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_10076_88545",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 60,
    width: 2,
    height: 2
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3115 60.8955H32.5195V61.0471H31.3115V60.8955Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_10076_88545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5195 60.9713C32.5195 60.9763 32.5154 60.9812 32.5078 60.9861C32.5 60.9909 32.4886 60.9957 32.4734 61.0003C32.4582 61.0049 32.4397 61.0092 32.4176 61.0134C32.3956 61.0175 32.3705 61.0213 32.3424 61.0248C32.3145 61.0284 32.2839 61.0315 32.2509 61.0343C32.218 61.0371 32.1833 61.0394 32.1465 61.0413C32.1098 61.0432 32.0721 61.0446 32.0333 61.0456C31.9943 61.0466 31.955 61.0471 31.9155 61.0471C31.8757 61.0471 31.8364 61.0466 31.7977 61.0456C31.7587 61.0446 31.7209 61.0432 31.6842 61.0413C31.6477 61.0394 31.6127 61.0371 31.5798 61.0343C31.5469 61.0315 31.5162 61.0284 31.4884 61.0248C31.4602 61.0213 31.4352 61.0175 31.4131 61.0134C31.3911 61.0092 31.3726 61.0049 31.3574 61.0003C31.3422 60.9957 31.3308 60.9909 31.3229 60.9861C31.3153 60.9812 31.3115 60.9763 31.3115 60.9713C31.3115 60.9663 31.3153 60.9614 31.3229 60.9565C31.3308 60.9516 31.3422 60.9469 31.3574 60.9423C31.3726 60.9377 31.3911 60.9333 31.4131 60.9292C31.4352 60.9251 31.4602 60.9212 31.4884 60.9177C31.5162 60.9142 31.5469 60.911 31.5798 60.9083C31.6127 60.9055 31.6477 60.9032 31.6842 60.9013C31.7209 60.8994 31.7587 60.8979 31.7977 60.897C31.8364 60.896 31.8757 60.8955 31.9155 60.8955C31.955 60.8955 31.9943 60.896 32.0333 60.897C32.0721 60.8979 32.1098 60.8994 32.1465 60.9013C32.1833 60.9032 32.218 60.9055 32.2509 60.9083C32.2839 60.911 32.3145 60.9142 32.3424 60.9177C32.3705 60.9212 32.3956 60.9251 32.4176 60.9292C32.4397 60.9333 32.4582 60.9377 32.4734 60.9423C32.4886 60.9469 32.5 60.9516 32.5078 60.9565C32.5154 60.9614 32.5195 60.9663 32.5195 60.9713Z",
    fill: "#FA5B5B"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10076_88545",
    x1: 18.8318,
    y1: 11.8525,
    x2: 18.8318,
    y2: 32.8353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10076_88545",
    x1: 31.2843,
    y1: -3.79883,
    x2: 31.2843,
    y2: 24.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10076_88545",
    x1: 44.2521,
    y1: 12.2734,
    x2: 44.2521,
    y2: 32.8361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10076_88545"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 63,
    rx: 9,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileImage);
export default __webpack_public_path__ + "static/media/profile-image.24e228d716c988780f6c507e893acf01.svg";
export { ForwardRef as ReactComponent };